import {
    Component,
    OnInit,
    AfterViewInit,
    Input,
    Output,
    EventEmitter,
    ElementRef,
    HostListener,
    HostBinding,
    ViewChild
} from '@angular/core';

import {
    PopperController
} from 'ngx-popper';

import {
    ConstantsService
} from '../../core/upgraded-providers/constants';

interface ICreep {
    name?: string;
    className?: string;
    powers?: [];
}

@Component({
    selector: 'app-power',
    templateUrl: './power.component.pug',
    styleUrls: ['./power.component.less']
})
export class PowerComponent implements OnInit, AfterViewInit {
    @Input() power: any;
    @Input() powerName: string;
    @Input() powerLevel: number;
    @Input() creepLevel: number;
    @Input() readonly: boolean;

    @Output() inc: EventEmitter<any> = new EventEmitter<any>();

    @HostBinding('attr.readonly') get isReadonly() {
        return this.readonly;
    }
    @HostBinding('class.checking') isChecking = false;
    @HostBinding('class.available') get isAvailable() {
        return this.requiredLevel <= (this.creepLevel || 0);
    }
    @HostBinding('class.selected') get isSelected() {
        return this.powerLevel;
    }

    @ViewChild('icon', {static: false, read: ElementRef}) icon: ElementRef;
    @ViewChild(PopperController, {static: false}) popper;

    public powerInfo: any = {};

    constructor(
        private _CONSTANTS: ConstantsService
    ) {
    }

    ngOnInit(): void {
        this.powerInfo = this._CONSTANTS.POWER_INFO[this.power];
    }

    ngAfterViewInit(): void {
        this.icon.nativeElement.style.top = `${ this.icon.nativeElement.offsetTop - 45 }px`;
        this.icon.nativeElement.style.left = `${ this.icon.nativeElement.offsetLeft - 1 }px`;
    }

    @HostListener('click', [])
    onClick() {
        if (!this.isAvailable) {
            return;
        }

        this.isChecking = true;

        this.inc.emit(this.power);

        setTimeout(() => this.isChecking = false, 1000);
    }

    @HostListener('mouseover', [])
    onShow() {
        this.popper.show();
    }

    @HostListener('mouseout', [])
    onHide() {
        this.popper.hide();
    }

    get requiredLevel(): number {
        return this.powerInfo.level[this.powerLevel || 0];
    }
}
